import { useState } from 'react';

import ErrorComponent from '@/components/common/error-component/ErrorComponent';
import { WidgetComponent } from '@/forms/components/widget';

import classes from './Checkbox.module.scss';

const Checkbox = ({
	label,
	name,
	checked = false,
	inputArgs,
	readOnly,
	disabled,
	onChange,
	form,
	fieldClass = '',
}: WidgetComponent) => {
	const elId = `id_${name}`;

	const [innerChecked, setChecked] = useState(checked);
	const [errorAfterSubmit] = useState<string[] | null>(null);

	return (
		<section
			className={[classes.container, classes[name], fieldClass].join(' ')}
			data-error={errorAfterSubmit ? true : undefined}
		>
			<input
				form={form}
				className={classes.input}
				name={name}
				id={elId}
				onChange={(e) => {
					setChecked(e.target.checked);
					onChange(e.target.checked);
				}}
				disabled={disabled}
				readOnly={readOnly}
				{...(inputArgs || {})}
				checked={innerChecked}
				type='checkbox'
			/>
			<label htmlFor={elId}>{label}</label>
			{errorAfterSubmit?.map((i, idx) => {
				return (
					<ErrorComponent key={idx} clazz={classes.error}>
						{`*${i}`}
					</ErrorComponent>
				);
			})}
		</section>
	);
};

export default Checkbox;
